import round from 'lodash.round';

var calculateAnnualPercentDiscount = function calculateAnnualPercentDiscount(monthlyPrice, annualPrice) {
  var annualizedMonthlyCost = monthlyPrice * 12;
  var discountRatio = (annualizedMonthlyCost - annualPrice) / annualizedMonthlyCost;
  return round(discountRatio * 100);
};

export { calculateAnnualPercentDiscount as default };
//# sourceMappingURL=index.js.map
